var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarGreenHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3469 9.79512L13.1668 14.5727C13.2235 14.9014 13.0024 15.2131 12.6737 15.2698C12.5434 15.2925 12.4074 15.2717 12.2902 15.2094L8.00004 12.9537L3.70983 15.2094C3.6101 15.262 3.4976 15.2857 3.38509 15.2777C3.27259 15.2696 3.16459 15.2302 3.07333 15.164C2.98207 15.0977 2.91121 15.0072 2.86878 14.9027C2.82635 14.7982 2.81405 14.6839 2.83328 14.5727L3.65316 9.79512L0.182838 6.4117C0.0679221 6.29968 0.00217854 6.14662 5.31712e-05 5.98616C-0.0020722 5.82569 0.0595945 5.67094 0.171503 5.55592C0.26407 5.46147 0.384974 5.39913 0.517213 5.38023L5.3137 4.68315L7.45786 0.336271C7.6071 0.0377895 7.96981 -0.0850036 8.26829 0.0623481C8.38731 0.120911 8.48365 0.217256 8.54222 0.336271L10.6864 4.68315L15.4829 5.38023C15.8135 5.42935 16.0439 5.73539 15.9929 6.06599C15.974 6.19823 15.9117 6.31913 15.8172 6.4117L12.3469 9.79512ZM8.00004 11.8239L12.0455 13.9509L11.2724 9.4461L14.5459 6.25457L10.0222 5.59712L8.00004 1.49763V11.8239Z",
    fill: "#7CAD53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarGreenHalf);
export default __webpack_public_path__ + "static/media/icon_star_green_half.b6f280354aa467b8a513c79b09affd45.svg";
export { ForwardRef as ReactComponent };